import { makeStyles, Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core';

const useStyles = makeStyles((themes: Theme) =>
  createStyles({
    toolBar: {
      display: 'flex',
      backgroundColor: '#FFF',
      borderBottom: '1px solid #dbdbdb',
    },
  }),
);

export default useStyles;
